export class DistributionNumberRange {
    distributionNumberRangeId: number;
    auctionClusterId: number;
    masterDataListRowId: number;
    distributionNumberRangeType: number;
    from: number;
    till: number;
  }